import { AddCircleOutline } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { ILocalityEquipmentMaintenance } from 'src/generated-types/maintenance'
import { useDialogCtx } from 'src/hooks/context-hooks'
import CreateMaintenanceForm from './CreateMaintenanceForm'
import MaintenanceTable from './MaintenanceTable'

interface MaintenanceTemplatesMaintenanceContainerProps {
  maintenances: ILocalityEquipmentMaintenance[]
  setMaintenances: React.Dispatch<React.SetStateAction<ILocalityEquipmentMaintenance[]>>
  modifiedMaintenanceIds?: number[]
  isUpdating?: boolean
}

const MaintenanceTemplatesMaintenanceContainer: React.FC<MaintenanceTemplatesMaintenanceContainerProps> = ({
  maintenances,
  setMaintenances,
  modifiedMaintenanceIds = [],
  isUpdating = false,
}) => {
  const { showDialog } = useDialogCtx()

  const onAdd = () => {
    showDialog(
      CreateMaintenanceForm,
      {
        componentProps: {
          addMaintenance: maintenance => {
            setMaintenances([...maintenances, maintenance])
          },
          isCustomMaintenance: false,
          isLocalityMaintenance: true,
          onSuccess: (pop) => {
            pop()
          }
        },
        opts: {
          maxWidth: 'sm',
          fullWidth: true,
        },
      },
      undefined,
      true,
    )
  }

  const { t: translate } = useTranslation(['maintenance'])
  const theme = useTheme()
  return (
    <div style={{ padding: '8px' }}>
      <CommonPageLayout
        titleSection={{ subtitle: translate('maintenances', { ns: 'maintenance' }) }}
        topAction={[
          {
            buttonText: translate('add-maintenance', { ns: 'maintenance' }),
            buttonIcon: <AddCircleOutline sx={{ color: theme.palette.primaryMain[theme.palette.mode] }} />,
            variant: 'contained',
            shadowWeight: null,
            border: 0,
            onClick: onAdd,
            disabled: isUpdating,
          },
        ]}
      >
        <MaintenanceTable maintenances={maintenances} setMaintenances={setMaintenances} modifiedMaintenanceIds={modifiedMaintenanceIds} isUpdating={isUpdating} />
      </CommonPageLayout>
    </div>
  )
}

export default MaintenanceTemplatesMaintenanceContainer
